import { Compass, Ship, Boxes, Tags } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const ICONS = [Compass, Ship, Boxes, Tags];

const Services = () => {
  const { t } = useLang();

  return (
    <section id="services" data-testid="services-section" className="section-pad bg-[#F3F3EF]">
      <div className="container-cust">
        <div className="max-w-3xl mb-16">
          <p className="eyebrow mb-5">
            <span className="eyebrow-line"></span>
            {t.services.eyebrow}
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#1A2421] leading-tight">
            {t.services.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E2E2DB]">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="group bg-[#FAFAF8] p-8 lg:p-10 transition-all duration-300 hover:bg-white"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#0E5A4E]/10 text-[#0E5A4E] mb-8 rounded-sm group-hover:bg-[#0E5A4E] group-hover:text-white transition-colors duration-300">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-serif-display text-xl lg:text-2xl text-[#1A2421] mb-4 leading-tight">
                  {item.title}
                </h3>
                <p className="text-sm text-[#4A5D58] leading-relaxed">{item.desc}</p>
                <div className="mt-6 inline-flex items-center text-xs uppercase tracking-widest text-[#0E5A4E] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  0{i + 1}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
